import type { AddEditAdditionalExpensesModalFormProps } from '../components/modals/AddEditAdditionalExpenses/form/types'
import type { AddEditAdditionalExpensesRequestProps } from '@services/api/otherExpenses/types'

export const parseAdditionalExpensesPayload = (formData: AddEditAdditionalExpensesModalFormProps) => {
  const payload: AddEditAdditionalExpensesRequestProps = {
    routeParams: {
      filiCode: formData.filiCode,
      expensesId: formData.id || null
    },
    bodyParams: {
      competenceDate: formData.competenceDate,
      accountingCode: formData.accountDescription,
      accountingDescription: formData.accountDescriptionText,
      value: formData.additionalExpensesValue ? Number(formData.additionalExpensesValue) : 0,
      observations: formData.observations || ''
    }
  }

  return payload
}
